import React, {Fragment, useEffect, useState} from 'react';
import Grid from "@mui/material/Grid";
import Collapse from "@mui/material/Collapse";
import FontAwesome from "../../components/UiStyle/FontAwesome";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {totalPrice} from "../../utils";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import MesafeliSatis from '../../agrements/MesafeliSatis'
import TeslimatVeIade from '../../agrements/TeslimatVeIade';
import GizlilikPolitikasi from '../../agrements/GizlilikPolitikasi';
import { MatchLocationToCurrency } from '../../main-component/Extensions/MatchLocationToCurrency';
import { useNavigate } from "react-router-dom";
// images
import visa from '../../images/icon/visa.png';
import mastercard from '../../images/icon/mastercard.png';
import iyzico from '../../images/icon/iyzico_ile_ode_colored_horizontal.png'

import CheckWrap from '../CheckWrap'

import './style.scss';
import { useSelector } from 'react-redux';
import { useGetCouponByCodeMutation } from '../../api/couponApi';

const cardType = [
    {
        title: 'visa',
        img: visa
    },
    {
        title: 'mastercard',
        img: mastercard
    },
    {
        title: 'iyzico',
        img: iyzico
    },
];

const CheckoutSection = ({cartList}) => {
    const navigate = useNavigate();
    const userDetail = useSelector((state) => state.authStore);

    console.log("trigger userDetails",userDetail);


    useEffect(() => {
        if (!userDetail) {
            navigate("/login", { state: { from: "/checkout" } });
            return;
        }
    }, [userDetail, navigate]);

    // states
    const [applyCode] = useGetCouponByCodeMutation();
    const cartState = useSelector((state) => state.cartStore);
    const guestCart = useSelector((state) => state.guestCartStore);
    const [cartLists,setCartLists] = useState([]);
    const [cartItems, setCartItems] = useState([]);
    const [isAgreementOpen, setIsAgreementOpen] = useState(false);
    const [isRefundAgreementOpen, setIsRefundAgreementOpen] = useState(false);
    const [isSecurityAgreementOpen, setIsSecurityAgreementOpen] = useState(false);
    const [couponDiscount, setCouponDiscount] = useState(0);

    const handleOpenAgreement = () => {
        setIsAgreementOpen(true);
    };
    
    const handleCloseAgreement = () => {
        setIsAgreementOpen(false);
    };
    

    const handleCancelOpenAgreement = () => {
        setIsRefundAgreementOpen(true);
    };
    
    const handleCancelCloseAgreement = () => {
        setIsRefundAgreementOpen(false);
    };


    const handleSecurityOpenAgreement = () => {
        setIsSecurityAgreementOpen(true);
    };
    
    const handleSecurityCloseAgreement = () => {
        setIsSecurityAgreementOpen(false);
    };

    useEffect(() => {
        if (!userDetail) {
            // Redirect guest users to login with return URL
            navigate("/login", { state: { from: "/checkout" } });
            return;
        }
        
        // Use server cart or guest cart based on auth status
        if (userDetail) {
            const basketItems = localStorage.getItem("basketItems");
            if (basketItems) {
                setCartItems(JSON.parse(basketItems));
            }
        } else {
            setCartItems(guestCart.items || []);
        }
    }, [userDetail, guestCart])

    const [tabs, setExpanded] = React.useState({
        cupon: false,
        billing_adress: false,
        payment: true
    });
    const [forms, setForms] = React.useState({
        cupon_key: '',
        payment_method: 'cash',
        card_type: '',
        card_holder: '',
        card_number: '',
        cvv: '',
        expire_date: '',
    });

    const [dif_ship, setDif_ship] = React.useState(false);

    // tabs handler
    function faqHandler(name) {
        setExpanded({
            cupon: false,
            billing_adress: false,
            payment: true, [name]: !tabs[name]
        });
    }



    // forms handler
    const changeHandler = e => {
        setForms({...forms, [e.target.name]: e.target.value})
    };

    const checkCouponForApply = async (e) => {
        e.preventDefault();
    
        await applyCode(forms.cupon_key).then((response) => {
            if (response.data.result) {
                const discount = response.data.result.discountAmount; // İndirim yüzdesi veya miktarı
                setCouponDiscount(discount); // İndirimi state'e atayın
            } else {
            }
        });
    };

    return (
        <Fragment>
            <div className="modern-checkout-wrapper">
                <div className="checkout-container">
                    <div className="checkout-grid">
                        {/* Sol Taraf - Payment & Coupon */}
                        <div className="checkout-left">
                            {/* Kupon Kartı */}
                            <div className="modern-card coupon-card">
                                <button 
                                    className="card-header" 
                                    onClick={() => faqHandler('cupon')}
                                >
                                    <div className="header-content">
                                        <i className="fi flaticon-discount"></i>
                                        <span className="header-title">Kupon Kodunuz Var mı?</span>
                                    </div>
                                    <i className={`fi ${tabs.cupon ? 'flaticon-up-arrow' : 'flaticon-down-arrow'}`}></i>
                                </button>
                                <Collapse in={tabs.cupon} timeout="auto" unmountOnExit>
                                    <div className="card-body">
                                        <p className="card-description">Kupon kodunuzu girerek indirimden faydalanın</p>
                                        <form className="coupon-form" onSubmit={checkCouponForApply}>
                                            <div className="input-group">
                                                <TextField
                                                    fullWidth
                                                    type="text"
                                                    placeholder="Kupon kodunu girin..."
                                                    className="modern-input"
                                                    value={forms.cupon_key}
                                                    name="cupon_key"
                                                    onChange={(e) => changeHandler(e)}
                                                    variant="outlined"
                                                />
                                                <Button type='submit' className="apply-btn">
                                                    <i className="fi flaticon-checked"></i>
                                                    Uygula
                                                </Button>
                                            </div>
                                        </form>
                                    </div>
                                </Collapse>
                            </div>

                            {/* Ödeme Kartı */}
                            <div className="modern-card payment-card">
                                <button 
                                    className="card-header active" 
                                    onClick={() => faqHandler('payment')}
                                >
                                    <div className="header-content">
                                        <i className="fi flaticon-credit-card"></i>
                                        <span className="header-title">Ödeme Yöntemi</span>
                                    </div>
                                    <i className={`fi ${tabs.payment ? 'flaticon-up-arrow' : 'flaticon-down-arrow'}`}></i>
                                </button>
                                <Collapse in={tabs.payment} timeout="auto">
                                    <div className="card-body">
                                        {/* Kart Tipleri */}
                                        <div className="payment-methods">
                                            {cardType.map((item, i) => (
                                                <div
                                                    key={i}
                                                    className={`payment-method-item ${forms.card_type === item.title ? 'active' : ''}`}
                                                    onClick={() => setForms({...forms, card_type: item.title})}
                                                >
                                                    <img src={item.img} alt={item.title}/>
                                                    <div className="check-mark">
                                                        <i className="fi flaticon-checked"></i>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        
                                        {/* Ödeme Formu */}
                                        <div className="payment-form-wrapper">
                                            <CheckWrap values={forms} />
                                        </div>

                                        {/* Sözleşmeler */}
                                        <div className="agreements-section">
                                            <h4 className="agreements-title">
                                                <i className="fi flaticon-file"></i>
                                                Yasal Metinler
                                            </h4>
                                            <div className="agreement-links">
                                                <button className="agreement-btn" onClick={handleOpenAgreement}>
                                                    <i className="fi flaticon-contract"></i>
                                                    Mesafeli Satış Sözleşmesi
                                                </button>
                                                <button className="agreement-btn" onClick={handleSecurityOpenAgreement}>
                                                    <i className="fi flaticon-shield"></i>
                                                    Gizlilik Politikası
                                                </button>
                                                <button className="agreement-btn" onClick={handleCancelOpenAgreement}>
                                                    <i className="fi flaticon-delivery-truck"></i>
                                                    Teslimat ve İade
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </Collapse>
                            </div>
                        </div>

                        {/* Sağ Taraf - Sepet Özeti */}
                        <div className="checkout-right">
                            <div className="modern-card cart-summary-card">
                                <div className="summary-header">
                                    <i className="fi flaticon-shopping-cart"></i>
                                    <h3>Sepet Özeti</h3>
                                </div>
                                
                                <div className="cart-items-list">
                                    {cartItems.map(item => (
                                        <div key={item.courseId} className="cart-item">
                                            <div className="item-info">
                                                <h4 className="item-name">{item.courseName}</h4>
                                                <span className="item-price">
                                                    {MatchLocationToCurrency()}{item.coursePrice}
                                                </span>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div className="summary-divider"></div>

                                <div className="summary-details">
                                    <div className="summary-row">
                                        <span className="label">
                                            <i className="fi flaticon-box"></i>
                                            Toplam Ürün
                                        </span>
                                        <span className="value">{cartItems.length}</span>
                                    </div>
                                    
                                    <div className="summary-row">
                                        <span className="label">
                                            <i className="fi flaticon-price-tag"></i>
                                            Ara Toplam
                                        </span>
                                        <span className="value">
                                            {couponDiscount === 0 ? (
                                                <span className="current-price">
                                                    {MatchLocationToCurrency()}{totalPrice(cartItems, 0)}
                                                </span>
                                            ) : (
                                                <div className="price-with-discount">
                                                    <span className="old-price">
                                                        {MatchLocationToCurrency()}{totalPrice(cartItems, 0)}
                                                    </span>
                                                    <span className="discounted-price">
                                                        {MatchLocationToCurrency()}{totalPrice(cartItems, couponDiscount)}
                                                    </span>
                                                </div>
                                            )}
                                        </span>
                                    </div>
                                    
                                    {couponDiscount > 0 && (
                                        <div className="summary-row discount-row">
                                            <span className="label">
                                                <i className="fi flaticon-discount"></i>
                                                İndirim
                                            </span>
                                            <span className="value discount-value">
                                                -{MatchLocationToCurrency()}{couponDiscount}
                                            </span>
                                        </div>
                                    )}
                                </div>

                                <div className="summary-divider"></div>

                                <div className="summary-total">
                                    <span className="total-label">Toplam Tutar</span>
                                    <span className="total-amount">
                                        {MatchLocationToCurrency()}{totalPrice(cartItems, couponDiscount)}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Dialog'lar */}
            <Dialog
                open={isAgreementOpen}
                onClose={handleCloseAgreement}
                fullWidth
                maxWidth="md"
                className="modern-dialog"
            >
                <DialogTitle className="dialog-title">
                    <i className="fi flaticon-contract"></i>
                    Mesafeli Satış Sözleşmesi
                </DialogTitle>
                <DialogContent dividers>
                    <MesafeliSatis />
                </DialogContent>
                <DialogActions className="dialog-actions">
                    <Button onClick={handleCloseAgreement} className="close-dialog-btn">
                        Kapat
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={isSecurityAgreementOpen}
                onClose={handleSecurityCloseAgreement}
                fullWidth
                maxWidth="md"
                className="modern-dialog"
            >
                <DialogTitle className="dialog-title">
                    <i className="fi flaticon-shield"></i>
                    Gizlilik Politikası
                </DialogTitle>
                <DialogContent dividers>
                    <GizlilikPolitikasi />
                </DialogContent>
                <DialogActions className="dialog-actions">
                    <Button onClick={handleSecurityCloseAgreement} className="close-dialog-btn">
                        Kapat
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={isRefundAgreementOpen}
                onClose={handleCancelCloseAgreement}
                fullWidth
                maxWidth="md"
                className="modern-dialog"
            >
                <DialogTitle className="dialog-title">
                    <i className="fi flaticon-delivery-truck"></i>
                    Teslimat ve İade
                </DialogTitle>
                <DialogContent dividers>
                    <TeslimatVeIade />
                </DialogContent>
                <DialogActions className="dialog-actions">
                    <Button onClick={handleCancelCloseAgreement} className="close-dialog-btn">
                        Kapat
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    )
};

export default CheckoutSection;
